<template>
  <div>
    LANGUAGE EDITING
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>